module.exports = __webpack_public_path__ + "img/painpoint5.ee18d2e5.png";